module.exports = __webpack_public_path__ + "assets/img/acBg.9039f171.png";